import React, { Component } from 'react';
import './Reserve.scss';

import { withNamespaces } from 'react-i18next';

// HTTP Request
import axios from 'axios';

// Icons from fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

library.add(faChevronDown);

class ReservePromo extends Component {
  closeBtn = React.createRef();

  // form
  arrival = React.createRef();
  leave = React.createRef();
  name = React.createRef();
  surname = React.createRef();
  country = React.createRef();
  city = React.createRef();
  phone = React.createRef();
  email = React.createRef();
  message = React.createRef();

  state = {
    suites: [],
    sent: false,
    canSend: false
  };

  componentDidMount() {
    document.querySelector('body').style = 'overflow: hidden';

    const api =
      'https://www.hotelnclapaz.com/restapi/public/api';
    // get rooms
    axios
      .get(`${api}/webroom`)
      .then(response => {
        const suites = response.data.result.data;
        this.setState({ suites });
      })
      .catch(error => {
        console.log(error);
      });
  }

  closeModal = () => {
    this.props.reserveModal.current.classList.remove('modal-reserve-up');
    this.props.reserveModal.current.classList.add('modal-reserve-down');
  };

  handleChange = event => {
    const arrival = this.arrival.current.value;
    const leave = this.leave.current.value;
    const name = this.name.current.value;
    const surname = this.surname.current.value;
    const country = this.country.current.value;
    const city = this.city.current.value;
    const phone = this.phone.current.value;
    const email = this.email.current.value;
    const message = this.message.current.value;

    if (
      arrival !== null &&
      arrival !== '' &&
      leave !== null &&
      leave !== '' &&
      name !== null &&
      name !== '' &&
      surname !== null &&
      surname !== '' &&
      country !== null &&
      country !== '' &&
      city !== null &&
      city !== '' &&
      phone !== null &&
      phone !== '' &&
      email !== null &&
      email !== '' &&
      message !== null &&
      message !== ''
    ) {
      return this.setState({ canSend: true });
    } else {
      return this.setState({ canSend: false });
    }
  };

  handleSubmit = event => {
    event.preventDefault();

    const {
      name,
      surname,
      country,
      city,
      phone,
      email,
      message,
      arrive,
      leave
    } = event.target;

    const data = {
      arrival: arrive.value,
      leave: leave.value,
      name: name.value,
      surname: surname.value,
      country: country.value,
      city: city.value,
      phone: phone.value,
      email: email.value,
      message: message.value
    };

    console.log(data);

    var params = {
      mailingcategory_id : 5,
      fields:{
        arrival: arrive.value,
        leave: leave.value,
        name: name.value,
        surname: surname.value,
        country: country.value,
        city: city.value,
        phone: phone.value,
        email: email.value,
        message: message.value
      }
    }

    console.log('form sending', data);
    axios.post('https://www.hotelnclapaz.com/restapi/public/api/sendform', params)
     .then(function(response){
       console.log(response);
       //Perform action based on response
   })
     .catch(function(error){
       console.log(error);
       //Perform action based on error
     });

    event.target.reset();

    this.setState({ sent: true });
  };

  render() {
    const { t } = this.props;
    if (!this.state.suites.length > 0) {
      return <div />;
    }

    if (this.state.sent) {
      return (
        <div
          className="Reserve modal-reserve-down"
          ref={this.props.reserveModal}>
          <div className="Reserve__header">
            <h4>{t('desc.header')}</h4>
            <button className="no-border" onClick={this.closeModal}>
              <FontAwesomeIcon icon={['fas', 'chevron-down']} />
            </button>
          </div>
          <div className="Reserve__body">
            <p className="p-1">{t('form.thanks')}</p>
            <button
              className="btn btn-primary"
              onClick={() => {
                this.setState({ sent: false });
                this.props.reserveModal.current.classList.remove(
                  'modal-reserve-up'
                );
                this.props.reserveModal.current.classList.add(
                  'modal-reserve-down'
                );
              }}>
              {t('form.continue')}
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="Reserve modal-reserve-down" ref={this.props.reserveModal}>
        <div className="Reserve__header">
          <h4>{t('desc.header')}</h4>
          <button className="no-border" onClick={this.closeModal}>
            <FontAwesomeIcon icon={['fas', 'chevron-down']} />
          </button>
        </div>
        <div className="Reserve__body">
          {/* Form */}
          <form
            onSubmit={this.handleSubmit}
            onChange={this.handleChange}
            noValidate>
            <div className="grid__form grid__form--header">
              <p>
                {this.props.price} USD. {t('form.perNight')}
              </p>
            </div>

            <div className="grid__form--calendar">
              <label htmlFor="arrive" className="label-large">
                {t('form.arrive')}
                <input
                  type="date"
                  id="arrive"
                  name="arrive"
                  ref={this.arrival}
                  required
                />
              </label>
              <label htmlFor="leave" className="label-large">
                {t('form.leave')}
                <input
                  type="date"
                  id="leave"
                  name="leave"
                  ref={this.leave}
                  required
                />
              </label>
            </div>

            <div className="grid__form">
              {/* Input */}
              <input
                type="text"
                className="custom-input"
                required
                placeholder={t('form.name')}
                ref={this.name}
                id="name"
                name="name"
              />
              {/* Input */}
              <input
                type="text"
                className="custom-input"
                required
                placeholder={t('form.surname')}
                ref={this.surname}
                id="surname"
                name="surname"
              />
              {/* Input */}
              <input
                type="text"
                className="custom-input"
                required
                placeholder={t('form.country')}
                ref={this.country}
                id="country"
                name="country"
              />
              {/* Input */}
              <input
                type="text"
                className="custom-input"
                required
                placeholder={t('form.city')}
                id="city"
                name="city"
                ref={this.city}
              />
              {/* Input */}
              <input
                type="text"
                className="custom-input"
                required
                placeholder={t('form.phone')}
                id="phone"
                name="phone"
                ref={this.phone}
              />
              {/* Input */}
              <input
                type="email"
                className="custom-input"
                required
                placeholder={t('form.email')}
                id="email"
                name="email"
                ref={this.email}
              />
            </div>
            <textarea
              className="custom-input"
              placeholder={t('form.message')}
              id="message"
              name="message"
              ref={this.message}
            />
            {/* textarea */}
            <p>{t('form.warning2')} 
            <a href={"mailto:" + "reservas@hotelnclapaz.com"}>
              reservas@hotelnclapaz.com
            </a>
            </p>
            <button disabled={!this.state.canSend} className="btn btn-primary">
             
                {t('form.submit')}
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default withNamespaces('translation')(ReservePromo);
